import { types } from "../../actions/auth";
import { INITIAL_STATE } from "../initial-state";

export const auth = (state = INITIAL_STATE.auth, action) => {
  switch (action.type) {
    case types.AUTH_LOGIN_SUCCESS: {
      console.log("[REDUCER] AUTH_LOGIN_SUCCESS:", action.payload);
      return {
        ...state,
        user: action.payload?.user || {},
        token: action.payload?.token || null,
        twoFA: {
          ...INITIAL_STATE.auth.twoFA,
          context: { ...INITIAL_STATE.auth.twoFA.context },
        },
      };
    }

    case types.AUTH_LOGIN_FAIL: {
      console.log("[REDUCER] AUTH_LOGIN_FAIL:", action.payload);
      return {
        ...state,
        user: {},
        token: null,
        error: "",
        twoFA: {
          ...INITIAL_STATE.auth.twoFA,
          context: { ...INITIAL_STATE.auth.twoFA.context },
        },
      };
    }

    case types.AUTH_TOKEN_REFRESH_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        token: {
          ...state.token,
          tokenType: payload.tokenType,
          accessToken: payload.accessToken,
          refreshToken: payload.refreshToken
        }

      };
    }

    case types.AUTH_LOGOUT_SUCCESS: {
      console.log("[REDUCER] AUTH_LOGOUT_SUCCESS");
      return {
        ...state,
        user: {},
        error: "",
        token: null,
        twoFA: {
          ...INITIAL_STATE.auth.twoFA,
          context: { ...INITIAL_STATE.auth.twoFA.context },
        },
      };
    }

    case types.AUTH_LOGOUT_FAIL: {
      console.log("[REDUCER] AUTH_LOGOUT_FAIL:", action.data);
      return {
        ...state,
        user: {},
        token: null,
        error: action.data,
        twoFA: {
          ...INITIAL_STATE.auth.twoFA,
          context: { ...INITIAL_STATE.auth.twoFA.context },
        },
      };
    }

    case types.GET_NP_STAFF_USERS_REQUEST:
      return {
        ...state,
        npStaffUsers: [],
      };
    case types.GET_NP_STAFF_USERS_SUCCESS:
      return {
        ...state,
        npStaffUsers: action.payload,
      };
    case types.RESET_NP_STAFF_USERS_STATE:
      return {
        ...state,
        npStaffUsers: [],
      };

    case types.AUTH_2FA_REQUIRED: {
      console.log("[REDUCER] AUTH_2FA_REQUIRED:", action.payload);
      return {
        ...state,
        twoFA: {
          pendingToken: action.payload?.pendingToken || null,
          methods: action.payload?.methods || [],
          user: action.payload?.user || null,
          requestingSms: false,
          verifyingOtp: false,
          error: null,
          context: {
            ...INITIAL_STATE.auth.twoFA.context,
            ...(action.payload?.context || {}),
          },
        },
      };
    }

    case types.AUTH_2FA_REQUEST_OTP: {
      console.log("[REDUCER] AUTH_2FA_REQUEST_OTP");
      return {
        ...state,
        twoFA: {
          ...state.twoFA,
          requestingSms: true,
          error: null,
        },
      };
    }
    case types.AUTH_2FA_REQUEST_OTP_SUCCESS: {
      console.log("[REDUCER] AUTH_2FA_REQUEST_OTP_SUCCESS");
      return {
        ...state,
        twoFA: {
          ...state.twoFA,
          requestingSms: false,
          error: null,
        },
      };
    }
    case types.AUTH_2FA_REQUEST_OTP_FAILURE: {
      console.log("[REDUCER] AUTH_2FA_REQUEST_OTP_FAILURE:", action.payload);
      return {
        ...state,
        twoFA: {
          ...state.twoFA,
          requestingSms: false,
          error: action.payload || null,
        },
      };
    }

    case types.AUTH_2FA_VERIFY_ATTEMPT: {
      console.log("[REDUCER] AUTH_2FA_VERIFY_ATTEMPT");
      return {
        ...state,
        twoFA: {
          ...state.twoFA,
          verifyingOtp: true,
          error: null,
        },
      };
    }
    case types.AUTH_2FA_VERIFY_SUCCESS: {
      console.log("[REDUCER] AUTH_2FA_VERIFY_SUCCESS:", action.payload);
      return {
        ...state,
        user: action.payload?.user || {},
        token: action.payload?.token || null,
        twoFA: {
          ...INITIAL_STATE.auth.twoFA,
          context: { ...INITIAL_STATE.auth.twoFA.context },
        },
      };
    }
    case types.AUTH_2FA_VERIFY_FAILURE: {
      console.log("[REDUCER] AUTH_2FA_VERIFY_FAILURE:", action.payload);
      return {
        ...state,
        twoFA: {
          ...state.twoFA,
          verifyingOtp: false,
          error: action.payload || null,
        },
      };
    }

    default:
      return state;
  }
};
